<script>
  import { navigateTo } from "svelte-router-spa";
  import { toastNotifier, LoadingContent } from "@saztrek/firefly";
  import { getClient, query, mutate } from "svelte-apollo";

  import {
    EDIT_MANUFACTURER,
    GET_MANUFACTURER,
    INACTIVATE_MANUFACTURER
  } from "../../../../gql";

  import Panel from "../../../components/Panel.svelte";
  import ManufacturerForm from "./ManufacturerForm.svelte";

  export let currentRoute;

  const { id } = currentRoute.namedParams;

  const cancelUpdate = () => {
    navigateTo("manufacturers");
  };

  const client = getClient();

  let loading = false;

  const manufacturerOp = query(client, {
    query: GET_MANUFACTURER,
    variables: {
      code: decodeURIComponent(id)
    }
  });

  const inactivateManufacturer = async (event) => {
    const manufacturerData = { ...event.detail };
    loading = true;
    try {
      await mutate(client, {
        mutation: INACTIVATE_MANUFACTURER,
        variables: {
          code: manufacturerData.code
        }
      });
      toastNotifier.success(
        "Success!",
        `Manufacturer ${manufacturerData.code} has been deactivated`,
        7000
      );
      navigateTo("manufacturers");
    } catch (error) {
      loading = false;
      toastNotifier.danger("Failed to update.", `${error}`, 7000);
      // eslint-disable-next-line no-console
      console.error("cannot mutate", error.message);
    }
  };

  const editManufacturer = async (event) => {
    try {
      const manufacturerData = { ...event.detail };
      loading = true;

      await mutate(client, {
        mutation: EDIT_MANUFACTURER,
        variables: {
          editManufacturerInput: {
            code: manufacturerData.code,
            name: manufacturerData.name,
            version: manufacturerData.version
          }
        }
      });
      toastNotifier.success(
        "Success!",
        `Manufacturer ${manufacturerData.name} Updated`,
        7000
      );
      navigateTo("manufacturers");
    } catch (error) {
      loading = false;
      toastNotifier.danger("Failed to update.", `${error}`, 7000);
      // eslint-disable-next-line no-console
      console.error("cannot mutate", error.message);
    }
  };
</script>

<div class="w-full flex items-center flex-col justify-center pt-10">
  <Panel header="Update Manufacturer">
    {#await $manufacturerOp}
      <div class="p-10 w-full" style="min-height: 500px">
        <LoadingContent />
      </div>
    {:then result}
      <ManufacturerForm
        mode="edit"
        code={result.data.manufacturer.code}
        name={result.data.manufacturer.name}
        version={result.data.manufacturer.version}
        on:validManufacturer={editManufacturer}
        on:inactivateManufacturer={inactivateManufacturer}
        cancelAction={cancelUpdate}
        {loading}
        buttonLabel="Update" />
    {/await}

  </Panel>
</div>
